import { ErrorView } from './ErrorView';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '@/appInsights';

interface ViewErrorWrapperProps {
  children: React.ReactNode;
}

const PlainViewErrorWrapper = ({ children }: ViewErrorWrapperProps) => {
  return (
    <AppInsightsErrorBoundary appInsights={reactPlugin} onError={() => <ErrorView view="general" />}>
      {children}
    </AppInsightsErrorBoundary>
  );
};
PlainViewErrorWrapper.displayName = 'PlainViewErrorWrapper';

export default PlainViewErrorWrapper;
